import axios from "axios";

import { Constant } from "../../constants";
import { ApiConfig } from "../../configuration";
import { Md5 } from "../../utilities";

const ApiService = axios.create({
  baseURL: ApiConfig.baseUrlApi,
});

ApiService.interceptors.request.use((config) => {
  if(!localStorage.getItem(Constant.localStorageKey.userId)){
    window.location.replace(process.env.PUBLIC_URL + "/login");
  }

  config.params = {
    // add config params
    ...config.params,
    // add your default params
    "key": ApiConfig.key,
    "user": Md5.hash(localStorage.getItem(Constant.localStorageKey.userId)),
    "app": Md5.hash(ApiConfig.appId),
  };
  return config;
});

ApiService.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      window.location.replace(process.env.PUBLIC_URL + "/login");
    }

    return Promise.reject(error);
  }
);

export default ApiService;
